export default class PasswordMatch {
  constructor(node) {
    this.element = node;
    this.passwordInputs = this.element.querySelectorAll(".js-password-input");
    this.passwordInput = this.element.querySelector(".js-password-match-original");
    this.passwordRepeatWrapper = this.element.querySelector(".js-repeat-password");
    this.passwordRepeatInput = this.passwordRepeatWrapper.querySelector(".js-password-input");

    this.errorMessage = this.element.dataset.passwordErrorMessage;
    this.errorMessageVisible = false;
    this.timeout;

    this.passwordInputs.forEach((passwordInput) => {
      passwordInput.addEventListener("input", () => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.toggleErrorMessage();
        }, 500);
      });
    });
  }

  createErrorElement() {
    this.errorElement = document.createElement("span");
    this.errorElement.className = "error-message js-error-message";
    this.passwordRepeatWrapper.appendChild(this.errorElement);
    this.errorElement.innerText = this.errorMessage;

    this.errorMessageVisible = true;
  }

  toggleErrorMessage() {
    if (this.passwordRepeatInput.value.length == 0) {
      if (this.errorMessageVisible) {
        this.errorElement.remove();
        this.errorMessageVisible = false;
      }
      return;
    }

    if (this.passwordInput.value != this.passwordRepeatInput.value) {
      if (this.errorMessageVisible) {
        return;
      } else {
        this.createErrorElement();
        this.errorMessageVisible = true;
      }
    } else {
      if (this.errorMessageVisible) {
        this.errorElement.remove();
        this.errorMessageVisible = false;
      }
    }
  }
}
